var _class;
import React, { Component } from 'react';
import './index.scss';
import classNames from 'classnames';
import { observer } from 'mobx-react';
//import PropTypes from 'prop-types'
let Popover = observer(_class = class Popover extends Component {
  constructor(...args) {
    super(...args);
    this.handleDismiss = e => {
      const {
        onVisibleChange,
        popoverElement
      } = this.props;
      if (popoverElement) {
        if (this.contentElement) {
          if (!this.contentElement.contains(e.target) && !popoverElement?.contains?.(e.target)) return onVisibleChange(false);
        }
      }
      return null;
    };
  }
  componentDidMount() {
    const {
      popoverElement
    } = this.props;
    this.getPopoverPosition(popoverElement);
    document.addEventListener('mousedown', this.handleDismiss);
  }
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleDismiss);
  }
  getPopoverPosition(targetElement) {
    const {
      alignX
    } = this.props;
    const targetElementPosition = targetElement?.getBoundingClientRect();
    const contentPosition = this.contentElement?.children?.[0]?.getBoundingClientRect?.();
    if (targetElementPosition) {
      const {
        width,
        height
      } = targetElementPosition;
      const contentWidth = contentPosition?.width ?? 0;
      let x;
      switch (alignX) {
        case 'center':
          x = width / 2 - contentWidth / 2;
          break;
        case 'right':
          x = 0;
          break;
        case 'left':
          x = -contentWidth + width;
          break;
        default:
          x = width + contentWidth;
          break;
      }
      return {
        x,
        y: height
      };
    }
    return {};
  }
  render() {
    const {
      popoverElement,
      visible,
      contentClass
    } = this.props;
    const className = classNames('popover-content', {
      'popover-hidden': !visible
    }, contentClass);
    const {
      x,
      y
    } = this.getPopoverPosition(popoverElement);
    return <div ref={node => this.contentElement = node} className={className} style={{
      left: `${x}px`,
      top: `${y}px`
    }}>
        {this.props.children}
      </div>;
  }
}) || _class;
Popover.propTypes = {};
Popover.defaultProps = {};
Popover.displayName = 'Popover';
export default Popover;